<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>{{ data?.item ? ('common.edit' | t) + ' ' + data?.item?.name : ('vehicleIntelligence.hotlist.addInternal' | t) }}</h2>
  <mat-dialog-content class="mat-typography">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
    <ng-container *ngIf="dataSource?.data?.length">
      <mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8 manage-hotlist-table"
        [trackBy]="trackBy"
      >
        <ng-container matColumnDef="fieldName">
          <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.fieldName }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fieldType">
          <mat-header-cell *matHeaderCellDef>{{ 'common.type' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.fieldType }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="required">
          <mat-header-cell *matHeaderCellDef>{{ 'form.required' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <sn-icon *ngIf="element.required" fontSet="fal" fontIcon="fa-check"></sn-icon>
            <sn-icon *ngIf="!element.required" fontSet="fal" fontIcon="fa-xmark"></sn-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="hideInList">
          <mat-header-cell *matHeaderCellDef>{{ 'form.hideInList' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <sn-icon *ngIf="element.hideInList" fontSet="fal" fontIcon="fa-check"></sn-icon>
            <sn-icon *ngIf="!element.hideInList" fontSet="fal" fontIcon="fa-xmark"></sn-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="validation">
          <mat-header-cell *matHeaderCellDef>{{ 'form.validation' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.validation }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="minLength">
          <mat-header-cell *matHeaderCellDef>{{ 'form.minLength' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.minLength }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="maxLength">
          <mat-header-cell *matHeaderCellDef>{{ 'form.maxLength' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.maxLength }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="options">
          <mat-header-cell *matHeaderCellDef> {{ 'common.options' | t }} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ handleOptions(element.options) }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let element; let i = index">
            <button mat-icon-button [matTooltip]="'form.editField' | t" (click)="editField(i)" type="button">
              <sn-icon fontSet="fal" fontIcon="fa-pen"></sn-icon>
            </button>
            <button mat-icon-button [matTooltip]="'form.cloneField' | t" (click)="cloneField(i)" type="button">
              <sn-icon fontSet="fal" fontIcon="fa-clone"></sn-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              [matTooltip]="'form.deleteField' | t"
              (click)="deleteField(i)"
              type="button"
            >
              <sn-icon fontSet="fal" fontIcon="fa-trash-alt"></sn-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </ng-container>

    <div class="addFieldWrapper">
      <button mat-stroked-button color="accent" (click)="addField()" type="button">
        <sn-icon>add</sn-icon>
        {{ 'form.addField' | t }}
      </button>
    </div>

    <sn-form [form]="reasonForm" [fields]="reasonFormFields" [model]="reasonFormModel"></sn-form>
    <ng-container *ngIf="reasonOptions.length">
      <mat-list class="reasonOptionList">
        <mat-list-item *ngFor="let reason of reasonOptions; let i = index">
          <span class="reason-option">{{ reason }}</span>
          <button mat-icon-button color="warn" (click)="deleteReason(i)" type="button">
            <sn-icon fontSet="fal" fontIcon="fa-trash-alt"></sn-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </ng-container>

    <div class="addReasonOptionsWrapper">
      <button mat-stroked-button color="accent" (click)="addReasonOptions()" type="button">
        <sn-icon>add</sn-icon>
        {{ 'form.addReasonOptions' | t }}
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      *ngIf="data?.item && data?.canDelete"
      mat-button
      color="warn"
      mat-button
      type="button"
      (click)="delete()"
    >
      {{ 'common.delete' | t }}
    </button>
    <button mat-button mat-dialog-close type="button">{{ 'common.cancel' | t }}</button>
    <button
      mat-button
      color="success"
      [mtBasicSpinner]="isLoading"
      [disabled]="form.invalid"
      mat-button
      type="submit"
    >
      {{ 'common.save' | t }}
    </button>
  </mat-dialog-actions>
</form>
